import { diffWords } from 'diff';
import MarkdownIt from 'markdown-it';
import MessageFormatter from 'shared/helpers/MessageFormatter';

const md = new MarkdownIt({
  html: true,
  breaks: true,
  linkify: true,
  typographer: true,
});

const MARKDOWN_PREFIX_RE = /^(\s*(?:[-*+]|\d+\.)\s+|#{1,6}\s+|>\s+)/;

const wrapDiffSegment = (text, tag) => {
  return text
    .split('\n')
    .map(line => {
      if (!line) return '';

      const prefixMatch = line.match(MARKDOWN_PREFIX_RE);
      if (prefixMatch) {
        const prefix = prefixMatch[0];
        const content = line.slice(prefix.length);
        return content ? `${prefix}<${tag}>${content}</${tag}>` : prefix;
      }

      return `<${tag}>${line}</${tag}>`;
    })
    .join('\n');
};

// Returns diff-match-patch style tuples ([op, text] with op -1/0/1),
// the format prettyHtml and ChangeActivity consume.
export const compare = (oldText, newText) => {
  return diffWords(oldText, newText).map(part => {
    let op = 0;
    if (part.added) op = 1;
    else if (part.removed) op = -1;
    return [op, part.value];
  });
};

export const prettyHtml = diffArray => {
  const combined = diffArray
    .map(([op, text]) => {
      if (op === 0) return text;
      return wrapDiffSegment(text, op === 1 ? 'ins' : 'del');
    })
    .join('');

  return md.render(combined);
};

export const formatMarkdown = text => {
  return new MessageFormatter(text).formattedMessage;
};
